import { Grid, TextField } from '@mui/material';
import React from 'react';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';
import ITestData from '../interfaces/ITestData';

type CTestUiTextfieldsProps = {
	data: ITestData;
	setData: (data: ITestData) => void;
};

const CTestUiTextfields = (props: CTestUiTextfieldsProps) => {
	const { data, setData } = props;

	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<CAppSubTitle title="Size - Medium" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								helperText="Size is medium"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								helperText="Size is medium"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								helperText="Size is medium"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Size - Small" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Small"
								fullWidth
								helperText="Size is small"
								size="small"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Small"
								fullWidth
								helperText="Size is small"
								size="small"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Small"
								fullWidth
								helperText="Size is small"
								size="small"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Disabled - Medium" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								disabled
								helperText="Field disabled"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								disabled
								helperText="Field disabled"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								disabled
								helperText="Field disabled"
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Size - Medium" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								error
								helperText="Texte erreur"
								fullWidth
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								error
								helperText="Texte erreur"
								fullWidth
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								error
								helperText="Texte erreur"
								fullWidth
								size="medium"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Default" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								size="medium"
								helperText="Color is default"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								size="medium"
								helperText="Color is default"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								size="medium"
								helperText="Color is default"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Primary" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="primary"
								size="medium"
								helperText="Color is primary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="primary"
								size="medium"
								helperText="Color is primary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="primary"
								size="medium"
								helperText="Color is primary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Secondary" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="secondary"
								size="medium"
								helperText="Color is secondary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="secondary"
								size="medium"
								helperText="Color is secondary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="secondary"
								size="medium"
								helperText="Color is secondary"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Info" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="info"
								size="medium"
								helperText="Color is info"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="info"
								size="medium"
								helperText="Color is info"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="info"
								size="medium"
								helperText="Color is info"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Success" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="success"
								size="medium"
								helperText="Color is success"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="success"
								size="medium"
								helperText="Color is success"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="success"
								size="medium"
								helperText="Color is success"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Warning" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="warning"
								size="medium"
								helperText="Color is warning"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="warning"
								size="medium"
								helperText="Color is warning"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="warning"
								size="medium"
								helperText="Color is warning"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item sm={3}>
					<CAppSubTitle title="Colors - Error" />
					<Grid container spacing={3}>
						<Grid item sm={12}>
							<TextField
								label="TextField - Outlined - Medium"
								fullWidth
								color="error"
								size="medium"
								helperText="Color is error"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="outlined"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Filled - Medium"
								fullWidth
								color="error"
								size="medium"
								helperText="Color is error"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="filled"
							/>
						</Grid>
						<Grid item sm={12}>
							<TextField
								label="TextField - Standard - Medium"
								fullWidth
								color="error"
								size="medium"
								helperText="Color is error"
								value={data && data.textfield ? data.textfield : null}
								onChange={(e) =>
									setData({
										...data,
										textfield: e.target.value.toString(),
									})
								}
								variant="standard"
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiTextfields;
